/* eslint-disable react/destructuring-assignment */
/* eslint-disable @typescript-eslint/no-empty-function */
import {
  faCalendar,
  faGears,
  faLayerGroup,
  faUserLarge
} from '@fortawesome/pro-regular-svg-icons';
import moment from 'moment';
import { memo } from 'react';

import { EventCardRuntime } from './EventCardRuntime';
import {
  GenericCardRuntime,
  GenericCardRuntimeProps
} from './GenericCardRuntime';
import OldCardRuntime from './OldCardRuntime';
import { SchedulerCardRuntime } from './SchedulerCardRuntime';
import { useIsAutoscaling } from '../../hooks/useIsAutoscaling';

import featureFlagConstants from '~/common/helpers/featureFlagConstants';
import i18n from '~/common/helpers/i18n';
import useFeatureFlag from '~/common/hooks/useFeatureFlag';

const CardRuntime = (props: GenericCardRuntimeProps) => {
  const showNewAutoScalingExperience = useIsAutoscaling({
    triggerType: props.deployment.pipeline.triggerSpec?.type
  });
  const { RUN_WITH_RUNNING_REPLICAS } = featureFlagConstants;
  const { treatments } = useFeatureFlag([RUN_WITH_RUNNING_REPLICAS]);
  const showNewCardWithRunningReplicas =
    treatments[RUN_WITH_RUNNING_REPLICAS].treatment === 'on';

  if (!showNewAutoScalingExperience && !showNewCardWithRunningReplicas)
    return <OldCardRuntime {...(props as any)} />;

  switch (props.deployment.pipeline.triggerSpec?.type) {
    case 'event':
      return <EventCardRuntime {...props} />;
    case 'scheduler':
      return <SchedulerCardRuntime {...props} />;
    default:
      return (
        <GenericCardRuntime
          {...props}
          infos={[
            [
              {
                icon: faCalendar,
                value: moment(props.deployment.startTime, 'x').format(
                  'DD/MM/YYYY HH:mm:ss'
                )
              },
              {
                icon: faGears,
                title: i18n.t('label.engine_version'),
                value: props.disabledMenu
                  ? null
                  : props.deployment.deploymentStatus?.pipelineEngineVersion?.replace(
                      /^([^.]*\.[^.]*\.[^.]*).*/,
                      '$1'
                    )
              }
            ],
            [
              {
                icon: faUserLarge,
                value: props.deployment.metadata?.userName
              },
              {
                icon: faLayerGroup,
                title: i18n.t('common.labels.multi_instance'),
                value: props.deployment.pipeline?.parameterizedReplica
                  ? 'Multi-instance'
                  : null
              }
            ]
          ]}
        />
      );
  }
};

export default memo(CardRuntime);
